((function () {
  "use strict";
  if (window.nicheProd) return;
  function initCarousel(root) {
    if (root.dataset.npReady) return;
    root.dataset.npReady = "1";
    var track = root.querySelector("[data-np-track]"),
      dotsBox = root.querySelector("[data-np-dots]"),
      prev = root.querySelector("[data-np-prev]"),
      next = root.querySelector("[data-np-next]");
    if (!track) return;

    var isDesktop = window.matchMedia("(min-width: 768px)").matches,
      autoplay = isDesktop
        ? root.dataset.autoplayDesktop === "true"
        : root.dataset.autoplay === "true",
      interval = parseInt(root.dataset.interval || "4000", 10),
      loop = root.dataset.loop !== "false";

    var vp = document.createElement("div");
    vp.className = "np-carousel__viewport";
    vp.style.overflow = "hidden";
    track.parentNode.insertBefore(vp, track);
    vp.appendChild(track);

    track.style.overflow = "visible";
    track.style.scrollSnapType = "none";
    track.classList.add("embla__container");

    var embla = null;
    if (window.EmblaCarousel) {
      embla = window.EmblaCarousel(vp, { loop: loop, align: "start", containScroll: "trimSnaps", slidesToScroll: 1, skipSnaps: false, dragFree: false });
    } else {
      var checkEmbla = setInterval(function() {
        if (window.EmblaCarousel) {
          clearInterval(checkEmbla);
          embla = window.EmblaCarousel(vp, { loop: loop, align: "start", containScroll: "trimSnaps", slidesToScroll: 1, skipSnaps: false, dragFree: false });
          setupEmbla();
        }
      }, 50);
    }

    function setupEmbla() {
      if (!embla) return;

      var timer;
      function play() {
        if (autoplay) {
          clearInterval(timer);
          timer = setInterval(function () {
            if (!document.hidden) embla.scrollNext();
          }, Math.max(1000, interval));
        }
      }
      function stop() {
        clearInterval(timer);
      }
      play();
      embla.on("pointerDown", stop);
      embla.on("pointerUp", play);

      if (prev) {
        prev.addEventListener("click", function () {
          embla.scrollPrev();
          stop();
          play();
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          embla.scrollNext();
          stop();
          play();
        });
      }

      var dots = [];
      if (dotsBox) {
        function setupDots() {
          dotsBox.innerHTML = "";
          dots = [];
          var snaps = embla.scrollSnapList();
          if (snaps.length <= 1) {
            dotsBox.style.display = "none";
            if (prev && prev.closest("[data-np-nav]")) prev.closest("[data-np-nav]").style.display = "none";
            return;
          }
          dotsBox.style.display = "";
          if (prev && prev.closest("[data-np-nav]")) prev.closest("[data-np-nav]").style.display = "";
          snaps.forEach(function (_, i) {
            var b = document.createElement("button");
            b.type = "button";
            b.className = "np-carousel__dot";
            b.dataset.i = i;
            b.setAttribute("aria-label", "Go to slide " + (i + 1));
            b.addEventListener("click", function () {
              embla.scrollTo(i);
              stop();
              play();
            });
            dotsBox.appendChild(b);
            dots.push(b);
          });
        }
        setupDots();
        embla.on("reInit", setupDots);
        embla.on("select", function () {
          var idx = embla.selectedScrollSnap();
          dots.forEach(function (d, i) {
            d.setAttribute("aria-current", i === idx ? "true" : "false");
          });
        });
        embla.emit("select");
      }
    }
    
    if (embla) setupEmbla();
  }
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll(".np-reveal:not(.is-in)");
    if (els.length) {
      if (
        !("IntersectionObserver" in window) ||
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) {
        els.forEach(function (el) {
          el.classList.add("is-in");
        });
        return;
      }
      var io = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (en) {
            en.isIntersecting &&
              (obs.unobserve(en.target), en.target.classList.add("is-in"));
          });
        },
        { rootMargin: "0px 0px -8% 0px", threshold: 0.05 },
      );
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          el.classList.add("is-in");
          return;
        }
        io.observe(el);
      });
    }
  }
  var ZOOM = 2.5;
  function initGallery(root) {
    if (root.dataset.npReady) return;
    root.dataset.npReady = "1";
    var main = root.querySelector("[data-np-gal-main]"),
      frame = root.querySelector("[data-np-gal-frame]"),
      track = root.querySelector("[data-np-gal-track]"),
      track = root.querySelector("[data-np-gal-track]"),
      imgs = Array.prototype.slice.call(
        root.querySelectorAll("[data-np-gal-img]"),
      ),
      thumbs = Array.prototype.slice.call(
        root.querySelectorAll("[data-np-gal-thumb]"),
      ),
      rail = root.querySelector("[data-np-rail]"),
      counter = root.querySelector("[data-np-gal-count]"),
      dotsBox = root.querySelector("[data-np-gal-dots]"),
      lens = root.querySelector("[data-np-gal-lens]"),
      zoomBox = root.querySelector("[data-np-gal-zoom]"),
      zoomImg = zoomBox && zoomBox.querySelector("img"),
      lb = root.querySelector("[data-np-lightbox]"),
      lbImg = lb && lb.querySelector("[data-np-lb-img]"),
      lbStage = lb && lb.querySelector("[data-np-lb-stage]"),
      lbCount = lb && lb.querySelector("[data-np-lb-count]"),
      lbThumbs = lb
        ? Array.prototype.slice.call(lb.querySelectorAll("[data-np-lb-thumb]"))
        : [],
      i = 0,
      count = imgs.length;
    if (!count) return;
    function full(k) {
      return imgs[k].dataset.zoom || imgs[k].currentSrc || imgs[k].src;
    }
    if (dotsBox && count > 1) {
      for (var d = 0; d < count; d++) {
        var b = document.createElement("button");
        ((b.type = "button"),
          (b.className = "np-carousel__dot"),
          (b.dataset.i = d),
          b.setAttribute("aria-label", "Go to image " + (d + 1)),
          dotsBox.appendChild(b));
      }
      dotsBox.addEventListener("click", function (e) {
        var t = e.target.closest(".np-carousel__dot");
        t && show(parseInt(t.dataset.i, 10));
      });
    }
    var track = root.querySelector("[data-np-gal-track]");
    function show(n) {
      if (
        ((i = (n + count) % count),
        track && (track.style.transform = "translateX(-" + i * 100 + "%)"),
        imgs.forEach(function (im, k) {
          k === i &&
            im.dataset.src &&
            ((im.src = im.dataset.src), im.removeAttribute("data-src"));
        }),
        thumbs.forEach(function (t) {
          var isCur = parseInt(t.dataset.i, 10) === i;
          if (
            (t.setAttribute("aria-current", isCur ? "true" : "false"),
            isCur && rail)
          ) {
            var rRect = rail.getBoundingClientRect(),
              tRect = t.getBoundingClientRect();
            (tRect.top < rRect.top || tRect.bottom > rRect.bottom) &&
              rail.scrollTo({
                top: t.offsetTop - rail.clientHeight / 2 + t.clientHeight / 2,
                behavior: "smooth",
              });
          }
        }),
        counter && (counter.textContent = i + 1 + " / " + count),
        dotsBox &&
          Array.prototype.forEach.call(dotsBox.children, function (dot, k) {
            dot.setAttribute("aria-current", k === i ? "true" : "false");
          }),
        zoomImg && (zoomImg.src = full(i)),
        rail)
      ) {
        var active = rail.querySelector(
          '[data-np-gal-thumb][aria-current="true"]',
        );
        if (active) {
          var top = active.offsetTop - rail.offsetTop;
          (top < rail.scrollTop ||
            top + active.offsetHeight > rail.scrollTop + rail.clientHeight) &&
            rail.scrollTo({ top: top - 8, behavior: "smooth" });
        }
      }
      var strip = root.querySelector(".np-gal__strip");
      if (strip) {
        var st = strip.querySelector(
          '[data-np-gal-thumb][aria-current="true"]',
        );
        st && strip.scrollTo({ left: st.offsetLeft - 16, behavior: "smooth" });
      }
      lb && lb.open && syncLightbox();
    }
    var fineMQ = window.matchMedia("(min-width: 1024px) and (pointer: fine)");
    function zoomable() {
      return fineMQ.matches;
    }
    (frame &&
      main &&
      (frame.addEventListener("pointerenter", function () {
        zoomable() && main.classList.add("is-zooming");
      }),
      frame.addEventListener("pointerleave", function () {
        main.classList.remove("is-zooming");
      }),
      frame.addEventListener("pointermove", function (e) {
        if (zoomable()) {
          var r = frame.getBoundingClientRect(),
            x = Math.min(
              100,
              Math.max(0, ((e.clientX - r.left) / r.width) * 100),
            ),
            y = Math.min(
              100,
              Math.max(0, ((e.clientY - r.top) / r.height) * 100),
            );
          (lens &&
            ((lens.style.width = 100 / ZOOM + "%"),
            (lens.style.height = 100 / ZOOM + "%"),
            (lens.style.left = x + "%"),
            (lens.style.top = y + "%")),
            zoomImg &&
              ((zoomImg.style.transform = "scale(" + ZOOM + ")"),
              (zoomImg.style.transformOrigin = x + "% " + y + "%")));
        }
      })),
      root.addEventListener("click", function (e) {
        var t = e.target.closest("[data-np-gal-thumb]");
        if (t) {
          show(parseInt(t.dataset.i, 10));
          return;
        }
        if (e.target.closest("[data-np-gal-prev]")) {
          (e.stopPropagation(), show(i - 1));
          return;
        }
        if (e.target.closest("[data-np-gal-next]")) {
          (e.stopPropagation(), show(i + 1));
          return;
        }
        if (e.target.closest("[data-np-rail-up]")) {
          railStep(-1);
          return;
        }
        if (e.target.closest("[data-np-rail-down]")) {
          railStep(1);
          return;
        }
        e.target.closest("[data-np-gal-frame]") && openLightbox();
      }));
    function railStep(dir) {
      if (rail) {
        var step = 176,
          max = rail.scrollHeight - rail.clientHeight,
          next = rail.scrollTop + dir * step;
        (next > max + 4 && (next = 0),
          next < -4 && (next = max),
          rail.scrollTo({
            top: Math.max(0, Math.min(max, next)),
            behavior: "smooth",
          }));
      }
    }
    if (rail) {
      rail.addEventListener(
        "wheel",
        function (e) {
          rail.scrollHeight <= rail.clientHeight ||
            (e.preventDefault(), (rail.scrollTop += e.deltaY));
        },
        { passive: !1 },
      );
      var isDown = !1,
        startY,
        scrollTop;
      (rail.addEventListener("pointerdown", function (e) {
        e.pointerType === "touch" ||
          e.button !== 0 ||
          ((isDown = !0),
          (startY = e.pageY - rail.offsetTop),
          (scrollTop = rail.scrollTop),
          (rail.style.cursor = "grabbing"));
      }),
        window.addEventListener("pointerup", function () {
          ((isDown = !1), rail && (rail.style.cursor = ""));
        }),
        window.addEventListener("pointermove", function (e) {
          if (isDown) {
            e.preventDefault();
            var y = e.pageY - rail.offsetTop,
              walk = (y - startY) * 2;
            rail.scrollTop = scrollTop - walk;
          }
        }));
      var railBtns = root.querySelectorAll(
        "[data-np-rail-up],[data-np-rail-down]",
      );
      requestAnimationFrame(function () {
        var fits = rail.scrollHeight <= rail.clientHeight + 2;
        Array.prototype.forEach.call(railBtns, function (b2) {
          b2.hidden = fits;
        });
      });
    }
    if (frame) {
      var x0 = null;
      (frame.addEventListener(
        "touchstart",
        function (e) {
          x0 = e.touches[0].clientX;
        },
        { passive: !0 },
      ),
        frame.addEventListener(
          "touchend",
          function (e) {
            if (x0 !== null) {
              var dx = e.changedTouches[0].clientX - x0;
              (Math.abs(dx) > 40 && show(dx < 0 ? i + 1 : i - 1), (x0 = null));
            }
          },
          { passive: !0 },
        ));
    }
    function syncLightbox() {
      lbImg &&
        ((lbImg.src = full(i)),
        (lbImg.alt = imgs[i].alt || ""),
        lbCount && (lbCount.textContent = i + 1 + " / " + count),
        lbThumbs.forEach(function (t) {
          t.setAttribute(
            "aria-current",
            parseInt(t.dataset.i, 10) === i ? "true" : "false",
          );
        }));
    }
    function openLightbox() {
      lb &&
        (syncLightbox(), typeof lb.showModal == "function" && lb.showModal());
    }
    (lb &&
      (lb.addEventListener("click", function (e) {
        var t = e.target.closest("[data-np-lb-thumb]");
        if (t) {
          show(parseInt(t.dataset.i, 10));
          return;
        }
        if (e.target.closest("[data-np-lb-prev]")) {
          show(i - 1);
          return;
        }
        if (e.target.closest("[data-np-lb-next]")) {
          show(i + 1);
          return;
        }
        if (
          e.target.closest("[data-np-lb-zoom]") ||
          e.target.closest("[data-np-lb-img]")
        ) {
          lbStage && lbStage.classList.toggle("is-zoomed");
          return;
        }
      }),
      lbStage &&
        lbStage.addEventListener("pointermove", function (e) {
          if (!(!lbStage.classList.contains("is-zoomed") || !lbImg)) {
            var r = lbStage.getBoundingClientRect();
            lbImg.style.transformOrigin =
              ((e.clientX - r.left) / r.width) * 100 +
              "% " +
              ((e.clientY - r.top) / r.height) * 100 +
              "%";
          }
        }),
      lb.addEventListener("close", function () {
        lbStage && lbStage.classList.remove("is-zoomed");
      }),
      lb.addEventListener("keydown", function (e) {
        (e.key === "ArrowRight" && (e.preventDefault(), show(i + 1)),
          e.key === "ArrowLeft" && (e.preventDefault(), show(i - 1)));
      })),
      root.addEventListener("np:variant-media", function (e) {
        show((e.detail && e.detail.index) || 0);
      }),
      show(0));
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-np-readmore]");
    if (btn) {
      var body = document.getElementById(btn.getAttribute("aria-controls"));
      if (body) {
        var open = body.classList.toggle("np-clamp") === !1;
        ((btn.textContent = open ? btn.dataset.less : btn.dataset.more),
          btn.setAttribute("aria-expanded", String(open)));
      }
    }
  });
  function initReadMore(card) {
    var body = card.querySelector("[data-np-clamp]"),
      btn = card.querySelector("[data-np-readmore]");
    !body ||
      !btn ||
      (body.scrollHeight - body.clientHeight < 4 && (btn.hidden = !0));
  }
  (document.addEventListener("np:color-change", function (e) {
    var value = ((e.detail && e.detail.value) || "").toLowerCase();
    document.querySelectorAll("[data-np-color-image]").forEach(function (img) {
      var src = img.dataset.colorDefault;
      (["colorAlt", "colorAlt2"].forEach(function (k) {
        var pair = img.dataset[k];
        if (pair) {
          var parts = pair.split("|");
          parts[0] && value && value.indexOf(parts[0]) > -1 && (src = parts[1]);
        }
      }),
        src &&
          img.getAttribute("src") !== src &&
          (img.removeAttribute("srcset"), (img.src = src)));
    });
  }),
    document.addEventListener("click", function (e) {
      var open = e.target.closest("[data-np-dialog-open]");
      if (open) {
        var d = document.getElementById(
          open.getAttribute("data-np-dialog-open"),
        );
        if (d) {
          e.preventDefault();
          var lazy = d.querySelector("template[data-np-lazy]");
          if (
            (lazy &&
              lazy.parentNode.replaceChild(lazy.content.cloneNode(!0), lazy),
            typeof d.showModal == "function"
              ? d.showModal()
              : d.setAttribute("open", ""),
            window.jdgm)
          )
            try {
              (window.jdgm.customizeBadges && window.jdgm.customizeBadges(),
                window.jdgm.initializeWidgets &&
                  window.jdgm.initializeWidgets());
            } catch {}
        }
        return;
      }
      var close = e.target.closest("[data-np-dialog-close]");
      if (close) {
        var dc = close.closest("dialog");
        dc && dc.close();
      }
    }),
    document.addEventListener("click", function (e) {
      e.target.tagName === "DIALOG" &&
        e.target.classList.contains("np-modal") &&
        e.target.close();
    }));

  function openSizeGuideModal() {
    var modal = document.getElementById("sizeGuideModal-xyz") || document.querySelector(".size-guide-modal-xyz");
    if (!modal) {
      modal = document.createElement("div");
      modal.className = "size-guide-modal-xyz";
      modal.id = "sizeGuideModal-xyz";
      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-modal", "true");
      modal.setAttribute("aria-label", "Size Guide");
      modal.innerHTML = '<div class="size-guide-content-xyz"><span class="size-guide-close-xyz" id="closeSizeGuide-xyz" aria-label="Close">&times;</span><img src="https://cdn.shopify.com/s/files/1/0808/5504/0277/files/Size_chart_Pop-up_1.png?v=1743535624" alt="Size Guide"></div>';
      document.body.appendChild(modal);
    }
    modal.classList.add("show");
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeSizeGuideModal() {
    var modals = document.querySelectorAll(".size-guide-modal-xyz, #sizeGuideModal-xyz");
    modals.forEach(function (m) {
      m.classList.remove("show");
      m.classList.remove("is-open");
    });
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest(".size-guide-trigger, [data-size-guide-trigger], .size-guide-link, a[href*='size-guide'], a[href*='size-chart'], [data-npb-sizeguide]");
    if (trigger) {
      e.preventDefault();
      openSizeGuideModal();
      return;
    }

    var parentDetails = e.target.closest("details");
    if (parentDetails && e.target.tagName === "IMG" && !e.target.closest(".size-guide-modal-xyz")) {
      var summaryText = (parentDetails.querySelector("summary") ? parentDetails.querySelector("summary").textContent : "").toLowerCase();
      if (summaryText.indexOf("size") > -1) {
        e.preventDefault();
        openSizeGuideModal();
        return;
      }
    }

    if (e.target.closest(".size-guide-close-xyz, #closeSizeGuide-xyz")) {
      e.preventDefault();
      closeSizeGuideModal();
      return;
    }

    if (e.target.classList.contains("size-guide-modal-xyz")) {
      closeSizeGuideModal();
      return;
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeSizeGuideModal();
    }
  });
  function boot(scope) {
    scope = scope || document;
    var io =
      "IntersectionObserver" in window
        ? new IntersectionObserver(
            function (entries, obs) {
              entries.forEach(function (en) {
                en.isIntersecting &&
                  (obs.unobserve(en.target),
                  en.target.matches("[data-np-carousel]") &&
                    initCarousel(en.target),
                  en.target.matches("[data-np-testimonial]") &&
                    initReadMore(en.target));
              });
            },
            { rootMargin: "200px" },
          )
        : null;
    if (
      (scope.querySelectorAll("[data-np-carousel]").forEach(function (el) {
        io ? io.observe(el) : initCarousel(el);
      }),
      scope.querySelectorAll("[data-np-testimonial]").forEach(function (el) {
        io ? io.observe(el) : initReadMore(el);
      }),
      scope.querySelectorAll("[data-np-gallery]").forEach(initGallery),
      window.jdgm)
    )
      try {
        (window.jdgm.customizeBadges && window.jdgm.customizeBadges(),
          window.jdgm.initializeWidgets && window.jdgm.initializeWidgets());
      } catch {}
    var revealSel =
      ".np-head, .np-band__card, .np-tech__card, .np-tst__card, .np-logos__cell, .np-spot__frame, .np-cmp__scroll, .np-benefits__item, .np-rev__badge, .np-faq .np-acc";
    (scope.querySelectorAll(revealSel).forEach(function (el) {
      el.closest(".np-buybox") || el.classList.add("np-reveal");
    }),
      initReveal(scope));
  }
  (document.readyState !== "loading"
    ? boot()
    : document.addEventListener("DOMContentLoaded", function () {
        boot();
      }),
    document.addEventListener("shopify:section:load", function (e) {
      boot(e.target);
    }),
    (window.nicheProd = { boot, initCarousel, initGallery, initReveal }));
})(),
  document.querySelectorAll(".np-acc__item").forEach((item) => {
    const summary = item.querySelector("summary"),
      panel = item.querySelector(".np-acc__panel");
    !summary ||
      !panel ||
      item.addEventListener("click", (e) => {
        e.target.closest("summary") &&
          (e.preventDefault(),
          item.hasAttribute("open")
            ? item.removeAttribute("open")
            : item.setAttribute("open", ""));
      });
  }),
  (window.initBuyBox = function (UID) {
    var root = document.getElementById("npb-" + UID);
    if (!root || root.dataset.npbInit === "1") return;
    root.dataset.npbInit = "1";
    var data = JSON.parse(
      document.querySelector('[data-npb-data="' + UID + '"]').textContent,
    );
    if (
      data.sizeGroups &&
      data.sizeGroups.length === 1 &&
      data.sizeGroups[0].sizes
    ) {
      for (
        var allSizes = data.sizeGroups[0].sizes,
          hasWomens = !1,
          hasMens = !1,
          i = 0;
        i < allSizes.length;
        i++
      )
        (allSizes[i].toLowerCase().indexOf("women's") > -1 && (hasWomens = !0),
          allSizes[i].toLowerCase().replace("women's", "").indexOf("men's") > -1 && (hasMens = !0));
      if (hasWomens && hasMens) {
        for (
          var wg = { label: "WOMEN'S US", value: null, sizes: [] },
            mg = { label: "MEN'S US", value: null, sizes: [] },
            i = 0;
          i < allSizes.length;
          i++
        ) {
          var s = allSizes[i],
            isW = s.toLowerCase().indexOf("women's") > -1,
            isM = s.toLowerCase().replace("women's", "").indexOf("men's") > -1;
          !isW && !isM
            ? (wg.sizes.push(s), mg.sizes.push(s))
            : (isW && wg.sizes.push(s), isM && mg.sizes.push(s));
        }
        ((data.sizeGroups = [wg, mg]), (data.virtualGroups = !0));
      }
    }
    var q = function (sel, scope) {
        return (scope || root).querySelector(sel);
      },
      ZOOM = 2.5,
      VISIBLE = 5,
      SLOT = 88,
      state = { color: 0, group: 0, size: null, qty: 1, index: 0 };
    function images() {
      var c = data.colors[state.color];
      return c && c.images.length
        ? c.images
        : [{ src: "", zoom: "", thumb: "", alt: "" }];
    }
    function currentGroup() {
      return data.sizeGroups[state.group] || null;
    }
    function matches(v, size) {
      var c = data.colors[state.color],
        g = currentGroup();
      return !(
        (data.colorOptionIndex >= 0 &&
          c &&
          v.options[data.colorOptionIndex] !== c.name) ||
        (data.groupOptionIndex >= 0 &&
          g &&
          g.value &&
          v.options[data.groupOptionIndex] !== g.value) ||
        (data.sizeOptionIndex >= 0 &&
          size != null &&
          v.options[data.sizeOptionIndex] !== size)
      );
    }
    function variantFor(size) {
      for (var i2 = 0; i2 < data.variants.length; i2++)
        if (matches(data.variants[i2], size)) return data.variants[i2];
      return null;
    }
    function findVariant() {
      return variantFor(state.size);
    }
    var SVG = {
        up: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>',
      },
      mobTrack = q("[data-npb-mobtrack]"),
      mobDots = q("[data-npb-mobdots]"),
      mobThumbs = q("[data-npb-mobthumbs]"),
      railTrack = q("[data-npb-railtrack]"),
      railVp = q("[data-npb-railvp]"),
      rail = q("[data-npb-rail]"),
      railPrev = q("[data-npb-railprev]"),
      railNext = q("[data-npb-railnext]"),
      main = q("[data-npb-main]"),
      frame = q("[data-npb-frame]"),
      frameWrap = q("[data-npb-framewrap]"),
      lens = q("[data-npb-lens]"),
      count = q("[data-npb-count]"),
      fly = q("[data-npb-fly]"),
      flyImg = q("[data-npb-flyimg]"),
      railOffset = 0,
      emblaMob = null,
      emblaDesk = null,
      over = !1;
    var isInitialLoad = true;
    function buildGallery() {
      var imgs = images();
      state.index = 0;
      if (!isInitialLoad) {
        mobTrack.innerHTML = imgs
          .map(function (g) {
            return (
              '<div class="npb-mob__slide"><button type="button" data-npb-mobopen aria-label="Open full-screen image" style="display:block;width:100%"><img src="' +
              g.src +
              '" alt="' +
              esc(g.alt) +
              '" width="1200" height="1200" loading="lazy" decoding="async"></button></div>'
            );
          })
          .join("");
      }
      (mobDots.innerHTML = imgs
          .map(function (_, i2) {
            return (
              '<button type="button" data-npb-mobdot="' +
              i2 +
              '" aria-label="Go to image ' +
              (i2 + 1) +
              '"></button>'
            );
          })
          .join("")),
        (mobThumbs.innerHTML = imgs
          .map(function (g, i2) {
            return (
              '<button type="button" data-npb-mobthumb="' +
              i2 +
              '" aria-label="View image ' +
              (i2 + 1) +
              '"><img src="' +
              g.thumb +
              '" alt="" loading="lazy" decoding="async"></button>'
            );
          })
          .join("")),
        (railTrack.innerHTML = imgs
          .map(function (g, i2) {
            return (
              '<div class="npb-rail__cell"><button type="button" class="npb-thumb" data-npb-thumb="' +
              i2 +
              '" aria-label="View image ' +
              (i2 + 1) +
              '"><img src="' +
              g.thumb +
              '" alt="" width="200" height="200" loading="lazy" decoding="async"></button></div>'
            );
          })
          .join("")),
        (over = imgs.length > VISIBLE),
        rail.classList.toggle("npb-rail--carousel", over),
        (railPrev.hidden = !over),
        (railNext.hidden = !over),
        (railVp.style.height = over ? VISIBLE * SLOT + "px" : "auto"),
        (railTrack.style.transform = "translateY(0px)"),
        over || (railTrack.style.marginTop = "-8px"),
        emblaMob && emblaMob.destroy(),
        emblaDesk && emblaDesk.destroy(),
        window.EmblaCarousel &&
                  ((emblaMob = EmblaCarousel(mobTrack.parentElement, {
            loop: !0,
            align: "start",
            containScroll: "trimSnaps",
            slidesToScroll: 1,
            skipSnaps: false,
            dragFree: false,
            watchDrag: false,
            duration: 25,
          })),
          emblaMob.on("select", function () {
            state.index !== emblaMob.selectedScrollSnap() &&
              ((state.index = emblaMob.selectedScrollSnap()), render(!0));
          }),
          (emblaDesk = EmblaCarousel(railVp, {
            axis: "y",
            loop: !1,
            dragFree: !1,
            containScroll: "trimSnaps",
            align: "start",
            slidesToScroll: 1,
            duration: 35,
            skipSnaps: false,
            active: over,
          })),
          (function () {
            function updateRailNav() {
              if (!emblaDesk) return;
              if (railPrev) {
                railPrev.disabled = !emblaDesk.canScrollPrev();
                railPrev.classList.toggle("is-disabled", !emblaDesk.canScrollPrev());
              }
              if (railNext) {
                railNext.disabled = !emblaDesk.canScrollNext();
                railNext.classList.toggle("is-disabled", !emblaDesk.canScrollNext());
              }
            }
            emblaDesk.on("select", updateRailNav);
            emblaDesk.on("reInit", updateRailNav);
            updateRailNav();
          })(),
          railPrev && (railPrev.hidden = !over),
          railNext && (railNext.hidden = !over)),
        render();
      isInitialLoad = false;
    }
    function esc(s2) {
      return String(s2 ?? "").replace(/"/g, "&quot;");
    }
    function render(skipEmbla) {
      var imgs = images(),
        i2 = Math.min(state.index, imgs.length - 1),
        g = imgs[i2];
      ((main.src = g.src),
        main.removeAttribute("srcset"),
        (main.alt = g.alt),
        (main.style.opacity = "1"),
        (flyImg.src = g.zoom || g.src),
        (count.textContent = i2 + 1 + " / " + imgs.length),
        emblaMob && !skipEmbla && emblaMob.scrollTo(i2),
        emblaDesk && over && !skipEmbla && emblaDesk.scrollTo(i2),
        each("[data-npb-mobdot]", function (el, k) {
          el.setAttribute("aria-current", k === i2 ? "true" : "false");
        }),
        each("[data-npb-mobthumb]", function (el, k) {
          var isCurrent = k === i2;
          el.setAttribute("aria-current", isCurrent ? "true" : "false");
          if (isCurrent && mobThumbs && typeof el.scrollIntoView === "function" && !isInitialLoad) {
            el.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
          }
        }),
        each("[data-npb-thumb]", function (el, k) {
          el.setAttribute("aria-current", k === i2 ? "true" : "false");
        }),
        lbOpen && renderLb());
    }
    function each(sel, fn) {
      Array.prototype.forEach.call(
        root.querySelectorAll(sel),
        function (el, i2) {
          fn(el, i2);
        },
      );
    }
    function go(dir) {
      var n = images().length;
      ((state.index = (state.index + dir + n) % n), render());
    }
    (root.addEventListener("click", function (e) {
      var t = e.target.closest(
        "[data-npb-mobdot],[data-npb-mobthumb],[data-npb-thumb],[data-npb-mobprev],[data-npb-mobnext],[data-npb-deskprev],[data-npb-desknext],[data-npb-railprev],[data-npb-railnext],[data-npb-mobopen]",
      );
      if (t) {
        if (t.hasAttribute("data-npb-mobopen")) {
          openLb();
          return;
        }
        if (t.hasAttribute("data-npb-mobprev")) {
          emblaMob ? emblaMob.scrollPrev() : go(-1);
          return;
        }
        if (t.hasAttribute("data-npb-mobnext")) {
          emblaMob ? emblaMob.scrollNext() : go(1);
          return;
        }
        if (t.hasAttribute("data-npb-deskprev")) {
          (e.stopPropagation(), go(-1));
          return;
        }
        if (t.hasAttribute("data-npb-desknext")) {
          (e.stopPropagation(), go(1));
          return;
        }
        if (t.hasAttribute("data-npb-railprev")) {
          emblaDesk && emblaDesk.scrollPrev();
          return;
        }
        if (t.hasAttribute("data-npb-railnext")) {
          emblaDesk && emblaDesk.scrollNext();
          return;
        }
        var idx =
          t.getAttribute("data-npb-mobdot") ||
          t.getAttribute("data-npb-mobthumb") ||
          t.getAttribute("data-npb-thumb");
        idx !== null && ((state.index = parseInt(idx, 10)), render());
      }
    }),
      (function () {
        var x0 = null,
          vp = q("[data-npb-mobvp]");
        (vp.addEventListener(
          "touchstart",
          function (e) {
            x0 = e.touches[0].clientX;
          },
          { passive: !0 },
        ),
          vp.addEventListener(
            "touchend",
            function (e) {
              if (x0 !== null) {
                var dx = e.changedTouches[0].clientX - x0;
                ((x0 = null), Math.abs(dx) > 40 && go(dx < 0 ? 1 : -1));
              }
            },
            { passive: !0 },
          ));
      })());
    var fine = window.matchMedia("(min-width: 1024px) and (pointer: fine)");
    (frame.addEventListener("pointerenter", function () {
      fine.matches &&
        (frame.classList.add("is-zooming"),
        frameWrap.classList.add("is-zooming"));
    }),
      frame.addEventListener("pointerleave", function () {
        (frame.classList.remove("is-zooming"),
          frameWrap.classList.remove("is-zooming"));
      }),
      frame.addEventListener("pointermove", function (e) {
        if (fine.matches) {
          var r = frame.getBoundingClientRect(),
            x = Math.max(
              0,
              Math.min(100, ((e.clientX - r.left) / r.width) * 100),
            ),
            y = Math.max(
              0,
              Math.min(100, ((e.clientY - r.top) / r.height) * 100),
            );
          ((lens.style.left = x + "%"),
            (lens.style.top = y + "%"),
            (flyImg.style.transform = "scale(" + ZOOM + ")"),
            (flyImg.style.transformOrigin = x + "% " + y + "%"));
        }
      }),
      frame.addEventListener("click", function (e) {
        e.target.closest(".npb-arrow") || openLb();
      }),
      railVp &&
        (function () {
          var isWheelLocked = !1;
          railVp.addEventListener(
            "wheel",
            function (e) {
              if (!emblaDesk || !over) return;
              e.preventDefault();
              if (isWheelLocked) return;
              if (Math.abs(e.deltaY) > 15) {
                isWheelLocked = !0;
                if (e.deltaY > 0) {
                  emblaDesk.scrollNext();
                } else {
                  emblaDesk.scrollPrev();
                }
                setTimeout(function () {
                  isWheelLocked = !1;
                }, 50);
              }
            },
            { passive: !1 },
          );
        })());
    var lb = document.querySelector('[data-npb-lb="' + UID + '"]'),
      lbImg = lb.querySelector("[data-npb-lbimg]"),
      lbCount = lb.querySelector("[data-npb-lbcount]"),
      lbThumbs = lb.querySelector("[data-npb-lbthumbs]"),
      lbStage = lb.querySelector("[data-npb-lbstage]"),
      lbZoomLabel = lb.querySelector("[data-npb-lbzoomlabel]"),
      lbOpen = !1,
      lbZoomed = !1,
      prevOverflow = "";
    function renderLb() {
      var imgs = images(),
        i2 = state.index,
        g = imgs[i2];
      ((lbImg.src = g.zoom || g.src),
        (lbImg.alt = g.alt),
        (lbCount.textContent = i2 + 1 + " / " + imgs.length),
        (lbThumbs.innerHTML = imgs
          .map(function (t, k) {
            return (
              '<button type="button" data-npb-lbthumb="' +
              k +
              '" aria-current="' +
              (k === i2 ? "true" : "false") +
              '" aria-label="View image ' +
              (k + 1) +
              '"><img src="' +
              t.thumb +
              '" alt=""></button>'
            );
          })
          .join("")),
        setZoom(lbZoomed));
    }
    function setZoom(on) {
      ((lbZoomed = on),
        lbStage.classList.toggle("is-zoomed", on),
        (lbZoomLabel.textContent = on ? "Zoom out" : "Zoom in"),
        on || (lbImg.style.transform = ""));
    }
    function openLb() {
      ((lbOpen = !0),
        lb.classList.add("is-open"),
        (prevOverflow = document.body.style.overflow),
        (document.body.style.overflow = "hidden"),
        renderLb());
    }
    function closeLb() {
      ((lbOpen = !1),
        lb.classList.remove("is-open"),
        (lb.style.transform = ""),
        (lb.style.opacity = ""),
        (lb.style.transition = ""),
        (document.body.style.overflow = prevOverflow),
        setZoom(!1));
    }
    (lb.addEventListener("click", function (e) {
      var t = e.target.closest(
        "[data-npb-lbclose],[data-npb-lbprev],[data-npb-lbnext],[data-npb-lbzoom],[data-npb-lbthumb],[data-npb-lbstage]",
      );
      if (t) {
        if (t.hasAttribute("data-npb-lbclose")) return closeLb();
        if (t.hasAttribute("data-npb-lbprev")) return go(-1);
        if (t.hasAttribute("data-npb-lbnext")) return go(1);
        if (
          t.hasAttribute("data-npb-lbzoom") ||
          t.hasAttribute("data-npb-lbstage")
        )
          return setZoom(!lbZoomed);
        var k = t.getAttribute("data-npb-lbthumb");
        k !== null && ((state.index = parseInt(k, 10)), render());
      }
    }),
      (function () {
        var startX = 0,
          startY = 0,
          currentY = 0,
          isSwiping = false,
          isDraggingDown = false,
          lbBody = lb.querySelector(".npb-lb__body") || lb;

        lbBody.addEventListener(
          "touchstart",
          function (e) {
            if (
              e.touches.length !== 1 ||
              e.target.closest(
                "[data-npb-lbthumbs],[data-npb-lbprev],[data-npb-lbnext],[data-npb-lbzoom],[data-npb-lbclose]",
              )
            )
              return;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            currentY = startY;
            isSwiping = false;
            isDraggingDown = false;
            lb.style.transition = "none";
          },
          { passive: true },
        );

        lbBody.addEventListener(
          "touchmove",
          function (e) {
            if (lbZoomed || e.touches.length !== 1) return;
            var dx = e.touches[0].clientX - startX,
              dy = e.touches[0].clientY - startY;

            if (!isSwiping) {
              if (Math.abs(dy) > 10 || Math.abs(dx) > 10) {
                isSwiping = true;
                isDraggingDown = dy > 0 && Math.abs(dy) > Math.abs(dx);
              }
            }

            if (isDraggingDown && dy > 0) {
              currentY = e.touches[0].clientY;
              var dragDistance = Math.min(dy, 350);
              lb.style.transform =
                "translate3d(0, " + dragDistance + "px, 0)";
              lb.style.opacity = Math.max(0.3, 1 - dragDistance / 500);
            }
          },
          { passive: true },
        );

        lbBody.addEventListener(
          "touchend",
          function (e) {
            if (!isSwiping) return;
            var dy =
                (e.changedTouches[0]
                  ? e.changedTouches[0].clientY
                  : currentY) - startY,
              dx =
                (e.changedTouches[0]
                  ? e.changedTouches[0].clientX
                  : startX) - startX;

            lb.style.transition =
              "transform .22s cubic-bezier(0.2, 0.9, 0.4, 1), opacity .22s ease";

            if (isDraggingDown && dy > 60) {
              lb.style.transform = "translate3d(0, 100%, 0)";
              lb.style.opacity = "0";
              setTimeout(function () {
                closeLb();
              }, 200);
            } else if (
              !lbZoomed &&
              Math.abs(dx) > 50 &&
              Math.abs(dx) > Math.abs(dy)
            ) {
              lb.style.transform = "";
              lb.style.opacity = "";
              setTimeout(function () {
                lb.style.transition = "";
              }, 220);
              go(dx < 0 ? 1 : -1);
            } else {
              lb.style.transform = "";
              lb.style.opacity = "";
              setTimeout(function () {
                lb.style.transition = "";
              }, 220);
            }
            isSwiping = false;
            isDraggingDown = false;
          },
          { passive: true },
        );
      })(),
      lbStage.addEventListener("pointermove", function (e) {
        if (lbZoomed) {
          var r = lbStage.getBoundingClientRect(),
            x = ((e.clientX - r.left) / r.width) * 100,
            y = ((e.clientY - r.top) / r.height) * 100;
          ((lbImg.style.transform = "scale(2)"),
            (lbImg.style.transformOrigin = x + "% " + y + "%"));
        }
      }),
      document.addEventListener("keydown", function (e) {
        lbOpen &&
          (e.key === "Escape" && closeLb(),
          e.key === "ArrowRight" && go(1),
          e.key === "ArrowLeft" && go(-1));
      }));
    var colorName = q("[data-npb-colorname]"),
      swatchesEl = q("[data-npb-swatches]"),
      groupsEl = q("[data-npb-groups]"),
      sizesEl = q("[data-npb-sizes]"),
      varId = q("[data-npb-varid]"),
      priceEl = q("[data-npb-price]"),
      atcPrice = q("[data-npb-atcprice]"),
      atc = q("[data-npb-atc]"),
      qtyVal = q("[data-npb-qtyval]"),
      qtyInput = q("[data-npb-qtyinput]");
    function renderSwatches() {
      !swatchesEl ||
        data.colorOptionIndex < 0 ||
        (swatchesEl.innerHTML = data.colors
          .map(function (c, i2) {
            var t = c.images && c.images[0] ? c.images[0].thumb : "";
            return (
              '<button type="button" class="npb-swatch" data-npb-color="' +
              i2 +
              '" aria-pressed="' +
              (i2 === state.color ? "true" : "false") +
              '" aria-label="' +
              esc(c.name) +
              '">' +
              (t
                ? '<img src="' +
                  t +
                  '" alt="' +
                  esc(c.name) +
                  '" width="160" height="128" loading="eager" decoding="async">'
                : "") +
              "</button>"
            );
          })
          .join(""));
    }
    function renderGroups() {
      if (groupsEl) {
        var show = data.sizeGroups.length > 1;
        if (((groupsEl.hidden = !show), !show)) {
          groupsEl.innerHTML = "";
          return;
        }
        groupsEl.innerHTML = data.sizeGroups
          .map(function (g, i2) {
            return (
              '<button type="button" data-npb-group="' +
              i2 +
              '" aria-pressed="' +
              (i2 === state.group ? "true" : "false") +
              '">' +
              esc(g.label) +
              "</button>"
            );
          })
          .join("");
      }
    }
    function renderSizes() {
      if (sizesEl) {
        var g = currentGroup();
        if (!g) {
          sizesEl.innerHTML = "";
          return;
        }
        sizesEl.innerHTML = g.sizes
          .map(function (s2) {
            var v = variantFor(s2),
              isUnavailable = !v || !v.available,
              isMissing = !v,
              displayStr = s2;
            if (data.virtualGroups) {
              if (
                s2.toLowerCase().indexOf("women's") > -1 &&
                s2.toLowerCase().replace("women's", "").indexOf("men's") > -1
              )
                for (var parts = s2.split("/"), j = 0; j < parts.length; j++)
                  (g.label === "WOMEN'S US" &&
                    parts[j].toLowerCase().indexOf("women's") > -1 &&
                    (displayStr = parts[j]),
                    g.label === "MEN'S US" &&
                      parts[j].toLowerCase().indexOf("men's") > -1 &&
                      (displayStr = parts[j]));
              displayStr = displayStr
                .replace(/women's/gi, "")
                .replace(/men's/gi, "")
                .replace(/US\s*/gi, "")
                .trim();
            }
            return (
              '<button type="button" class="npb-size" data-npb-size="' +
              esc(s2) +
              '"' +
              (isMissing ? " disabled" : "") +
              ' aria-pressed="' +
              (state.size === s2 ? "true" : "false") +
              '">' +
              esc(displayStr) +
              (isUnavailable ? '<span class="npb-size__slash"></span>' : "") +
              "</button>"
            );
          })
          .join("");
      }
    }
    function syncVariant() {
      var v = findVariant();
      var bisBtn = q('.klaviyo-bis-trigger');
      var buyBtn = q('.npb-buy');
      var binBtn = q('.npb-bin');
      if (v) {
        varId.value = v.id;
        if (v.price) {
          if (priceEl) priceEl.textContent = v.price;
          if (atcPrice) atcPrice.textContent = v.price;
        }
        atc.disabled = !v.available;
        if (v.available) {
           if (buyBtn) buyBtn.style.display = '';
           if (binBtn) binBtn.style.display = '';
           if (bisBtn) bisBtn.style.display = 'none';
        } else {
           if (buyBtn) buyBtn.style.display = 'none';
           if (binBtn) binBtn.style.display = 'none';
           if (bisBtn) bisBtn.style.display = 'block';
        }
      } else {
        if (buyBtn) buyBtn.style.display = '';
        if (binBtn) binBtn.style.display = '';
        if (bisBtn) bisBtn.style.display = 'none';
      }
    }
    function applyColor() {
      var c = data.colors[state.color];
      c &&
        (colorName && (colorName.textContent = c.name),
        renderSwatches(),
        buildGallery(),
        renderGroups(),
        renderSizes(),
        syncVariant());
    }
    root.addEventListener("click", function (e) {
      var c = e.target.closest("[data-npb-color]");
      if (c) {
        ((state.color = parseInt(c.getAttribute("data-npb-color"), 10)),
          (state.size = null),
          applyColor());
        return;
      }
      var g = e.target.closest("[data-npb-group]");
      if (g) {
        ((state.group = parseInt(g.getAttribute("data-npb-group"), 10)),
          (state.size = null),
          each("[data-npb-group]", function (el, i2) {
            el.setAttribute(
              "aria-pressed",
              i2 === state.group ? "true" : "false",
            );
          }),
          renderSizes(),
          syncVariant());
        return;
      }
      var s2 = e.target.closest("[data-npb-size]");
      if (s2 && !s2.disabled) {
        ((state.size = s2.getAttribute("data-npb-size")),
          each("[data-npb-size]", function (el) {
            el.setAttribute(
              "aria-pressed",
              el.getAttribute("data-npb-size") === state.size
                ? "true"
                : "false",
            );
          }),
          syncVariant());
        return;
      }
      if (e.target.closest("[data-npb-qtydown]")) {
        ((state.qty = Math.max(1, state.qty - 1)),
          (qtyVal.textContent = state.qty),
          (qtyInput.value = state.qty));
        return;
      }
      if (e.target.closest("[data-npb-qtyup]")) {
        ((state.qty = Math.min(10, state.qty + 1)),
          (qtyVal.textContent = state.qty),
          (qtyInput.value = state.qty));
        return;
      }
    });
      var form = q("form.npb-form");
      (form &&
        form.addEventListener("submit", function (e) {
          if (data.sizeOptionIndex >= 0 && !state.size) {
            e.preventDefault();
            if (sizesEl) sizesEl.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
          }
          var hiddenAtc = form.querySelector('[data-btn-addtocart]');
          if (hiddenAtc && e.submitter !== hiddenAtc && (!e.submitter || e.submitter.name !== 'checkout')) {
            e.preventDefault();
            hiddenAtc.click();
          }
        }),
        applyColor());
  }));
//# sourceMappingURL=/cdn/shop/t/21/assets/niche-prod.js.map?v=171351955988695478831785997875
